import React, { useEffect } from 'react'
import { Modal } from 'antd'
import SignUpForm from '../pageComponents/signupForm'
import useGMT from '../../hooks/useGTM'

const CandidateSignUpModal = ({ closeHandler, form, modalOpen }) => {
  const { pushCandidateViewItemEvent } = useGMT()

  useEffect(() => {
    if (modalOpen) {
      pushCandidateViewItemEvent()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalOpen])

  return (
    <Modal
      width={1200}
      footer={null}
      onCancel={closeHandler}
      visible={modalOpen}
      okText="Save"
      className="p-b candidateAlertModal shadow-lg relative top-[75px]"
    >
      <SignUpForm inModal={true} closeHandler={closeHandler} form={form} />
    </Modal>
  )
}
export default CandidateSignUpModal
